import { PAY_ROLL } from '../actions/utilities';

const INITIAL_STATE = {
  generatePayRollLoading: false,
  generatePayRollSuccess: false,
  generatePayRollFailure: false,
  generatePayRollError: null,
  generatePayRoll: [],

  createPayrollLoading: false,
  createPayrollSuccess: false,
  createPayrollFailure: false,
  createPayrollError: null,
  createPayroll: [],

  createManualPayrollLoading: false,
  createManualPayrollSuccess: false,
  createManualPayrollFailure: false,
  createManualPayrollError: null,
  createManualPayroll: [],

  updatePayrollLoading: false,
  updatePayrollSuccess: false,
  updatePayrollFailure: false,
  updatePayrollError: null,
  updatePayroll: [],

  getPayrollByIdLoading: false,
  getPayrollByIdSuccess: false,
  getPayrollByIdFailure: false,
  getPayrollByIdError: null,
  getPayrollById: [],

  deletePayrollLoading: false,
  deletePayrollSuccess: false,
  deletePayrollFailure: false,
  deletePayrollError: null,
  deletePayroll: [],

  deleteManualPayrollLoading: false,
  deleteManualPayrollSuccess: false,
  deleteManualPayrollFailure: false,
  deleteManualPayrollError: null,
  deleteManualPayroll: [],

  getPayrollLoading: false,
  getPayrollSuccess: false,
  getPayrollFailure: false,
  getPayrollError: null,
  getPayroll: [],
  getPayrollRequestId: null,
};

export const PayRollReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PAY_ROLL.GENERATE_PAY_ROLL_REQUEST:
      return {
        ...state,
        generatePayRollLoading: true,
        generatePayRollSuccess: false,
        generatePayRollFailure: false,
        generatePayRollError: null,
        generatePayRoll: [],
      };
    case PAY_ROLL.GENERATE_PAY_ROLL_SUCCESS:
      return {
        ...state,
        generatePayRollLoading: false,
        generatePayRollSuccess: true,
        generatePayRollFailure: false,
        generatePayRollError: null,
        generatePayRoll: action.payload,
      };
    case PAY_ROLL.GENERATE_PAY_ROLL_FAILURE:
      return {
        ...state,
        generatePayRollLoading: false,
        generatePayRollSuccess: false,
        generatePayRollFailure: true,
        generatePayRollError: action.payload,
      };

    case PAY_ROLL.CREATE_PAY_ROLL_REQUEST:
      return {
        ...state,
        createPayrollLoading: true,
        createPayrollSuccess: false,
        createPayrollFailure: false,
        createPayrollError: null,
        createPayroll: [],
      };
    case PAY_ROLL.CREATE_PAY_ROLL_SUCCESS:
      return {
        ...state,
        createPayrollLoading: false,
        createPayrollSuccess: true,
        createPayrollFailure: false,
        createPayrollError: null,
        createPayroll: action.payload,
      };
    case PAY_ROLL.CREATE_PAY_ROLL_FAILURE:
      return {
        ...state,
        createPayrollLoading: false,
        createPayrollSuccess: false,
        createPayrollFailure: true,
        createPayrollError: action.payload,
      };

    case PAY_ROLL.CREATE_MANUAL_PAY_ROLL_REQUEST:
      return {
        ...state,
        createManualPayrollLoading: true,
        createManualPayrollSuccess: false,
        createManualPayrollFailure: false,
        createManualPayrollError: null,
        createManualPayroll: [],
      };
    case PAY_ROLL.CREATE_MANUAL_PAY_ROLL_SUCCESS:
      return {
        ...state,
        createManualPayrollLoading: false,
        createManualPayrollSuccess: true,
        createManualPayrollFailure: false,
        createManualPayrollError: null,
        createManualPayroll: action.payload,
      };
    case PAY_ROLL.CREATE_MANUAL_PAY_ROLL_FAILURE:
      return {
        ...state,
        createManualPayrollLoading: false,
        createManualPayrollSuccess: false,
        createManualPayrollFailure: true,
        createManualPayrollError: action.payload,
      };

    case PAY_ROLL.UPDATE_PAY_ROLL_REQUEST:
      return {
        ...state,
        updatePayrollLoading: true,
        updatePayrollSuccess: false,
        updatePayrollFailure: false,
        updatePayrollError: null,
        updatePayroll: [],
      };
    case PAY_ROLL.UPDATE_PAY_ROLL_SUCCESS:
      return {
        ...state,
        updatePayrollLoading: false,
        updatePayrollSuccess: true,
        updatePayrollFailure: false,
        updatePayrollError: null,
        updatePayroll: action.payload,
      };
    case PAY_ROLL.UPDATE_PAY_ROLL_FAILURE:
      return {
        ...state,
        updatePayrollLoading: false,
        updatePayrollSuccess: false,
        updatePayrollFailure: true,
        updatePayrollError: action.payload,
      };

    case PAY_ROLL.GET_PAY_ROLL_BY_ID_REQUEST:
      return {
        ...state,
        getPayrollByIdLoading: true,
        getPayrollByIdSuccess: false,
        getPayrollByIdFailure: false,
        getPayrollByIdError: null,
        getPayrollById: [],
      };
    case PAY_ROLL.GET_PAY_ROLL_BY_ID_SUCCESS:
      return {
        ...state,
        getPayrollByIdLoading: false,
        getPayrollByIdSuccess: true,
        getPayrollByIdFailure: false,
        getPayrollByIdError: null,
        getPayrollById: action.payload,
      };
    case PAY_ROLL.GET_PAY_ROLL_BY_ID_FAILURE:
      return {
        ...state,
        getPayrollByIdLoading: false,
        getPayrollByIdSuccess: false,
        getPayrollByIdFailure: true,
        getPayrollByIdError: action.payload,
      };

    case PAY_ROLL.DELETE_MANUAL_PAY_ROLL_REQUEST:
      return {
        ...state,
        deleteManualPayrollLoading: true,
        deleteManualPayrollSuccess: false,
        deleteManualPayrollFailure: false,
        deleteManualPayrollError: null,
        deleteManualPayroll: [],
      };
    case PAY_ROLL.DELETE_MANUAL_PAY_ROLL_SUCCESS:
      return {
        ...state,
        deleteManualPayrollLoading: false,
        deleteManualPayrollSuccess: true,
        deleteManualPayrollFailure: false,
        deleteManualPayrollError: null,
        deleteManualPayroll: action.payload,
      };
    case PAY_ROLL.DELETE_MANUAL_PAY_ROLL_FAILURE:
      return {
        ...state,
        deleteManualPayrollLoading: false,
        deleteManualPayrollSuccess: false,
        deleteManualPayrollFailure: true,
        deleteManualPayrollError: action.payload,
      };

    case PAY_ROLL.DELETE_PAY_ROLL_REQUEST:
      return {
        ...state,
        deletePayrollLoading: true,
        deletePayrollSuccess: false,
        deletePayrollFailure: false,
        deletePayrollError: null,
        deletePayroll: [],
      };
    case PAY_ROLL.DELETE_PAY_ROLL_SUCCESS:
      return {
        ...state,
        deletePayrollLoading: false,
        deletePayrollSuccess: true,
        deletePayrollFailure: false,
        deletePayrollError: null,
        deletePayroll: action.payload,
      };
    case PAY_ROLL.DELETE_PAY_ROLL_FAILURE:
      return {
        ...state,
        deletePayrollLoading: false,
        deletePayrollSuccess: false,
        deletePayrollFailure: true,
        deletePayrollError: action.payload,
      };

    case PAY_ROLL.GET_PAY_ROLL_REQUEST:
      return {
        ...state,
        getPayrollLoading: true,
        getPayrollSuccess: false,
        getPayrollFailure: false,
        getPayrollError: null,
        getPayroll: [],
        getPayrollRequestId: action.meta?.requestId ?? null,
      };
    case PAY_ROLL.GET_PAY_ROLL_SUCCESS:
      if (action.meta?.requestId != null && action.meta.requestId !== state.getPayrollRequestId) return state;
      return {
        ...state,
        getPayrollLoading: false,
        getPayrollSuccess: true,
        getPayrollFailure: false,
        getPayrollError: null,
        getPayroll: action.payload,
      };
    case PAY_ROLL.GET_PAY_ROLL_FAILURE:
      if (action.meta?.requestId != null && action.meta.requestId !== state.getPayrollRequestId) return state;
      return {
        ...state,
        getPayrollLoading: false,
        getPayrollSuccess: false,
        getPayrollFailure: true,
        getPayrollError: action.payload,
        getPayroll: [],
      };
    default:
      return state;
  }
};
